import { Page, PageTitle } from "@/components/page"
import { CRUDLoader } from "@/components/page/crudloader"
import { CRUDToolbar } from "@/components/page/crudtoolbar"
import { useDatabaseItem, usePage } from "@/components/page/hooks"
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { zodResolver } from "@hookform/resolvers/zod"
import { Globe } from "lucide-react"
import { useForm } from "react-hook-form"
import { z } from "zod"

export const domains_crud = {
  title: "Domain",
  route: "/docu/domains/:id",
  component,
  group: "docs",
  resource: "collections",
  icon: Globe,
  action: "read",
} satisfies PageConfig

const FormSchema = z.object({
  name: z.string().min(1, "Name is required"),
})

type FormData = z.infer<typeof FormSchema>

export function component() {
  const { data, loading, submit, toastSuccess, navigate } = useDatabaseItem("domains")
  const { team } = usePage()

  const form = useForm<FormData>({
    resolver: zodResolver(FormSchema),
    defaultValues: data,
    values: data,
  })

  async function onSubmit(data: FormData & { team: string }) {
    data.team = team?.id
    await submit(data)
    toastSuccess()
    navigate("/docu/domains")
  }

  if (loading) return <CRUDLoader />

  return <Page>
    <div className="pb-8">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <PageTitle>
            <CRUDToolbar table="domains" onSuccess={"/docu/domains"} />
          </PageTitle>
          <div className="rgrid">
            <div className="row">
              <div className="rc-6">
                <FormField control={form.control} name="name" render={({ field }) => (
                  <FormItem>
                    <FormLabel>Name</FormLabel>
                    <FormControl><Input {...field} /></FormControl>
                    <FormMessage />
                  </FormItem>
                )} />
              </div>
            </div>
          </div>
        </form>
      </Form>
    </div>
  </Page>
}
